const Loading = () => <div className="loading">待</div>

export default Loading;
